@if (subsequences?.length && hasSubsequences) {
  <div class="substatuses">
    @if (hasActiveSubsequence) {
      <div class="row">
        <h4 class="section title">Substatuses</h4>
      </div>
    }
    @if (hasActiveSubsequence) {
      <div class="row">
        @for (subsequence of activeSubsequences | async; track subsequence) {
          <div
            class="subsequence"
            >
            <div class="row">
              <div class="col-md-1">
                <h5 class="sequence title">
                  {{ subsequence.name }}
                  @if (subsequence?.permissions?._edit) {
                    <button
                      mat-mini-fab
                      matTooltip="Edit {{ subsequence.name }} Dates"
                      color="primary"
                      class="hide show-md"
                      (click)="toggleEditMode(subsequence)"
                      >
                      <mat-icon>{{
                        editModeSubsequence[subsequence.id] ? "check" : "edit"
                      }}</mat-icon>
                    </button>
                  }
                </h5>
              </div>
              <div
          [class]="
            subsequence.substatuses?.length < 4
              ? subsequence.substatuses?.length < 3
                ? 'col-md-4'
                : 'col-md-6'
              : 'col-md-11'
          "
                >
                <ul class="substatus-labels">
                  @for (substatus of subsequence.substatuses; track substatus) {
                    <li class="label">
                      <span>{{ substatus.name }}</span>
                    </li>
                  }
                </ul>
              </div>
            </div>
            <bubble-line
              [current]="subsequenceCurrentIndices[subsequence.id]"
              [scaling]="true"
              [items]="subsequence.substatuses"
              (moveStatus)="handleClick($event, subsequence)"
              [readOnly]="!subsequence.permissions?._edit || savingProjectSubstatuses"
            ></bubble-line>
            <div class="row">
              <div class="col-md-1"><h5 class="title">Actual/Target</h5></div>
              <div
          [class]="
            subsequence.substatuses?.length < 4
              ? subsequence.substatuses?.length < 3
                ? 'col-md-4'
                : 'col-md-6'
              : 'col-md-11'
          "
                >
                <ul
                  class="substatus-labels"
                  [class.edit-mode]="editModeSubsequence[subsequence.id]"
                  >
                  @for (substatus of subsequence.substatuses; track substatus) {
                    <li class="label">
                      <sub-status-date
                        class="inner-label"
                        [style.top]="editModeSubsequence[subsequence.id] ? 0 : null"
                        [substatus]="substatus"
                        [subsequence]="subsequence"
                        [project_status_id]="statusSequence.projectStatusID"
                        [editMode]="editModeSubsequence[subsequence.id]"
                      ></sub-status-date>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        }
      </div>
    }
    <div class="row">
      <div class="col-md-6">
        <h3 class="section title">
          Substatus Dates
          @if (anyEditPermissions) {
            <button
              mat-mini-fab
              matTooltip="Edit Substatus Dates"
              color="primary"
              (click)="toggleTableEditMode()"
              >
              <mat-icon>{{ editModeTable ? "check" : "edit" }}</mat-icon>
            </button>
          }
        </h3>
      </div>
      @if (hasWarehouseCredits()) {
        <div class="col-md-6">
          <h3 class="section title">
            Warehouse Deadlines
            @if (anyEditPermissions) {
              <button class="edit-button"
                mat-mini-fab
                matTooltip="Edit Warehouse Line Dates"
                color="primary"
                (click)="toggleWarehouseEditMode()"
                >
                @if (!editModeWarehouse) {
                  <i class="material-icons" style="font-size: 16px;">edit</i>
                }
                @if (editModeWarehouse) {
                  <i class="material-icons" style="font-size: 16px;">check</i>
                }
              </button>
            }
          </h3>
        </div>
      }
    </div>
    <div class="row scroll-x align-top gutters">
      <div class="col-md-6">
        <sub-status-dates-table
          [subsequences]="subsequences"
          [project_status_id]="statusSequence.projectStatusID"
          [editMode]="editModeTable"
          >
        </sub-status-dates-table>
      </div>
      @if (hasWarehouseCredits()) {
        <div class="col-md-6">
          <warehouse-line [projectCredits]="projectCredits" [editMode]="editModeWarehouse"></warehouse-line>
        </div>
      }
    </div>
    <ng-template #dash> &mdash; </ng-template>
    <ng-template #blank></ng-template>
  </div>
}
